import React, { useState } from "react";
import { Typography, Form, Input, Select, Button, Row, Col } from "antd";
import { LoadingOutlined, HomeOutlined } from '@ant-design/icons';
import "./style.scss";
import { getDadosAmbientais, getEndereco } from "./service";
import CardComponent from "Components/CardComponent";
import DadosAmbientaisModal from "./DadosAmbientaisModal";
import { useParams } from "react-router-dom";
import { sendErrorMsg } from "Misc/utils";

const { Text } = Typography;
const { Option } = Select;

const Endereco = (props) => {
  const {
    getFieldDecorator,
    isRequired,
    decoratorCep,
    decoratorRua,
    decoratorNumero,
    decoratorComplemento,
    decoratorBairro,
    decoratorCidade,
    decoratorEstado,
    resetFields,
    rotina,
    formItemLayout,
    titulo,
    subtitulo,
    readOnly,
  } = props;

  const states = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];

  const [rua, setRua] = useState(null);
  const [bairro, setBairro] = useState(null);
  const [cidade, setCidade] = useState(null);
  const [uf, setUF] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dadosModal, setDadosModal] = useState({});
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const { tarefa } = useParams();
  const [loadingModal, setLoadingModal] = useState(false);

  const buscarEndereco = async (cep) => {
    if (String(cep).length === 8) {
      setLoading(true);

      let data = await getEndereco(cep);
      if (data.endereco) {
        resetFields([
          decoratorRua,
          decoratorNumero,
          decoratorComplemento,
          decoratorBairro,
          decoratorCidade,
          decoratorEstado,
        ]);
        setRua(data.endereco.logradouro.slice(0, 60));
        setBairro(data.endereco.bairro.slice(0, 30));
        setCidade(data.endereco.cidade.slice(0, 25));
        setUF(data.endereco.uf);
      }
      setLoading(false);
    } else {
      setRua("");
      setBairro("");
      setCidade("");
      setUF("");
    }
  };

  const handleCancelar = async (value) => {
    setModalIsVisible(false);
    setTimeout(() => {
      setDadosModal({});
    }, 1000);
  };

  const handleOpenModal = async (id, nome) => {
    setLoadingModal(true);
    await getDadosAmbientais(tarefa)
      .then((res) => {
        setDadosModal(res.data)
        setModalIsVisible(true)
      })
      .catch((error) => sendErrorMsg(error));
    setLoadingModal(false);
  };

  const modal = () => {
    return (
      <DadosAmbientaisModal
        open={modalIsVisible}
        confirmLoading={false}
        onCancel={handleCancelar}
        dados={dadosModal}
      />
    );
  };

  return (
    <>
      {modal()}
      <CardComponent
        title="Endereço"
        classText="layoutInformacaoPessoal"
        rotina={rotina}
      >
        {!rotina && (
          <>
            <div className="cadastro-object-title">
              <HomeOutlined style={{ marginRight: "10px" }} />
              <Text className="cadastro-section-title">{titulo}</Text>
            </div>
            <Text className="cadastro-section-description color-gray">
              {subtitulo}
            </Text>
          </>
        )}
        <Form
          style={{ width: "100%" }}
          hideRequiredMark={true}
          colon={!!rotina}
          {...formItemLayout}
        >
          <Form.Item label="CEP">
            {getFieldDecorator(decoratorCep, {
              rules: [{ required: isRequired, message: "Insira o cep." }],
              initialValue: props.cep,
              getValueFromEvent: (cep) => {
                buscarEndereco(
                  cep.target.value.replace(/\D/gi, "").substring(0, 8)
                );
                return cep.target.value.replace(/\D/gi, "").substring(0, 8);
              },
            })(
              <Input
                size="large"
                style={{ width: "40%", minWidth: "170px" }}
                suffix={loading ? <LoadingOutlined /> : ""}
                allowClear
                disabled={readOnly}
              />
            )}
          </Form.Item>
          {!!rotina ? (
            <>
              <Form.Item label="Rua, avenida, etc">
                {getFieldDecorator(decoratorRua, {
                  rules: [{ required: isRequired, message: "Insira uma rua." }],
                  initialValue: rua || props.logradouro,
                })(
                  <Input
                    disabled={loading || readOnly}
                    size="large"
                    style={{ maxWidth: "500px", minWidth: "170px" }}
                    maxLength={60}
                  />
                )}
              </Form.Item>
              <Form.Item label="Número">
                {getFieldDecorator(decoratorNumero, {
                  rules: [{ required: isRequired, message: "Insira um número." }],
                  initialValue: props.numero,
                })(
                  <Input
                    style={{ width: "20%", minWidth: "100px" }}
                    disabled={loading || readOnly}
                    size="large"
                    maxLength={20}
                  />
                )}
              </Form.Item>
              <Form.Item label="Complemento">
                {getFieldDecorator(decoratorComplemento, {
                  initialValue: props.complemento,
                })(
                  <Input
                    style={{ width: "40%", minWidth: "170px" }}
                    disabled={loading || readOnly}
                    size="large"
                    maxLength={20}
                  />
                )}
                <span className="color-gray" style={{ marginLeft: "8px" }}>
                  (opcional)
                </span>
              </Form.Item>
            </>
          ) : (
            <Row gutter={16}>
              <Col span={14}>
                <Form.Item label="Rua, avenida, etc">
                  {getFieldDecorator(decoratorRua, {
                    rules: [{ required: isRequired, message: "Insira uma rua." }],
                    initialValue: rua || props.logradouro,
                  })(
                    <Input
                      disabled={loading || readOnly}
                      size="large"
                      maxLength={60}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="Número">
                  {getFieldDecorator(decoratorNumero, {
                    rules: [{ required: isRequired, message: "Insira um número." }],
                    initialValue: props.numero,
                  })(
                    <Input
                      disabled={loading || readOnly}
                      size="large"
                      maxLength={20}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="Complemento (opcional)">
                  {getFieldDecorator(decoratorComplemento, {
                    initialValue: props.complemento,
                  })(
                    <Input
                      disabled={loading || readOnly}
                      size="large"
                      maxLength={20}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          )}
          {!!rotina ? (
            <>
              <Form.Item label="Bairro">
                {getFieldDecorator(decoratorBairro, {
                  rules: [{ required: isRequired, message: "Insira o bairro." }],
                  initialValue: bairro || props.bairro,
                })(
                  <Input
                    style={{ width: "40%", minWidth: "170px" }}
                    disabled={loading || readOnly}
                    size="large"
                    maxLength={30}
                  />
                )}
              </Form.Item>
              <Form.Item label="Cidade">
                {getFieldDecorator(decoratorCidade, {
                  rules: [
                    { required: isRequired, message: "Insira uma cidade." },
                  ],
                  initialValue: cidade || props.cidade,
                })(
                  <Input
                    style={{ width: "40%", minWidth: "170px" }}
                    disabled={loading || readOnly}
                    size="large"
                    maxLength={25}
                  />
                )}
              </Form.Item>
              <Form.Item label="Estado">
                {getFieldDecorator(decoratorEstado, {
                  rules: [
                    { required: isRequired, message: "Selecione um estado." },
                  ],
                  initialValue: uf || props.uf,
                })(
                  <Select
                    style={{ width: "20%", minWidth: "100px" }}
                    disabled={loading || readOnly}
                    size="large"
                  >
                    {states.map((state) => (
                      <Option key={state} value={state}>
                        {state}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </>
          ) : (
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Bairro">
                  {getFieldDecorator(decoratorBairro, {
                    rules: [{ required: isRequired, message: "Insira o bairro." }],
                    initialValue: bairro || props.bairro,
                  })(
                    <Input
                      disabled={loading || readOnly}
                      size="large"
                      maxLength={30}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="Cidade">
                  {getFieldDecorator(decoratorCidade, {
                    rules: [
                      { required: isRequired, message: "Insira uma cidade." },
                    ],
                    initialValue: cidade || props.cidade,
                  })(
                    <Input
                      disabled={loading || readOnly}
                      size="large"
                      maxLength={25}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Estado">
                  {getFieldDecorator(decoratorEstado, {
                    rules: [
                      { required: isRequired, message: "Selecione um estado." },
                    ],
                    initialValue: uf || props.uf,
                  })(
                    <Select
                      style={{ width: "100%" }}
                      disabled={loading || readOnly}
                      size="large"
                    >
                      {states.map((state) => (
                        <Option key={state} value={state}>
                          {state}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
        <Button
          className="buttonFooterBack"
          onClick={() => handleOpenModal()}
          style={{ display: "table", marginLeft: "auto" }}
          disabled={!props.cep}
          loading={loadingModal}
        >
          Verificar previsão do tempo
        </Button>
      </CardComponent>
    </>
  );
};

export default Endereco;
